/**
 * Anzeigetexte für Auto Q&A — nie den Rezept-Prompt als Titel.
 *
 * Gelernt am 23.08.2026: `durchsicht_laeufe.prompt` trägt die komplette
 * Vorschrift. Wurde das als 40-Punkt-Titel gesetzt, sprengte ein Klick auf
 * „Durchsichtlauf öffnen“ die Seite.
 */

export function laufAnzeigetitel(lauf: {
  rezeptName?: string | null;
  prompt?: string | null;
}): string {
  const name = lauf.rezeptName?.trim();
  if (name) return name;
  return "Durchsicht";
}

export function schrittAnzeigename(
  schritt: { reihenfolge: number; rezeptName?: string | null },
): string {
  const name = schritt.rezeptName?.trim();
  if (name) return name;
  return `Schritt ${schritt.reihenfolge + 1}`;
}

export function zielTitelAusSchnappschuss(
  schnappschuss: string | null | undefined,
): string | null {
  if (!schnappschuss) return null;
  const zeile = schnappschuss.split("\n").find((eintrag) => /^#\s+\S/.test(eintrag));
  if (!zeile) return null;
  const titel = zeile.replace(/^#\s+/, "").trim();
  return titel.length > 0 ? titel : null;
}

export function zielKennungAusSchnappschuss(
  schnappschuss: string | null | undefined,
): string | null {
  if (!schnappschuss) return null;
  const treffer = schnappschuss.match(/^- Kennung:\s+(.+)$/m);
  const kennung = treffer?.[1]?.trim();
  if (!kennung || kennung === "nicht angegeben") return null;
  return kennung;
}
